import React, { Component } from "react";

export class NotFoundPage extends Component {
  render() {
    return (
      <div>
        not found page
      </div>
    );
  }
}

export default NotFoundPage;
